import {
  CreateSampleOrderSuccessResponse,
  Merch,
  MerchState,
  ProductSample,
} from './state';
import { merchInitialState } from './initial-state';
import { MerchActions } from './action-creators';
import * as actions from './actions';
import {
  CHANGE_MERCH_COLOR,
  CHANGE_MERCH_DESIGN_POSITION,
  CHANGE_MERCH_TYPE_SUCCESS,
  PUBLISH_PRODUCT_SUCCESS,
} from './actions';
import { MerchProduct } from '@services/merch/types/api/merch-product';
import { RelativePosition } from '@services/merch/types/api/create-product';
import { AssetFile } from '@common/types/data/asset-file';
import { CatalogItemColor } from '@services/merch/types/api/get-catalog-item';
import {
  ExpressShippingOption,
  StandardShippingOption,
} from '@webapp/utils/merch/constants';
import { ShippingOption } from '@services/payment/types/api/create-checkout-session-req';

export const merchReducer = (
  state: MerchState = merchInitialState,
  action: MerchActions
): MerchState => {
  switch (action.type) {
    case actions.LIST_MERCH_CATALOG_SUCCESS: {
      return {
        ...state,
        catalog: action.catalog,
      };
    }

    case actions.UPDATE_MERCH_STATUS_SUCCESS: {
      return {
        ...state,
        artistMerch: state.artistMerch.map((m) =>
          m.id === action.product.id ? action.product : m
        ),
      };
    }

    case actions.UPLOAD_MERCH_IMAGE_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          image: state.active?.image?.map((image, index) => {
            return {
              ...image,
              id: action.key === image.key ? action.data.imageId : image.id,
              imageId: image.id,
              position: index === 0 ? 'front' : index === 1 ? 'back' : 'neck',
              placeholder: {
                images: [
                  {
                    id:
                      action.key === image.key
                        ? action.data.imageId
                        : image.placeholder?.images?.[0].id ||
                          image.id ||
                          image.imageId ||
                          '',
                    x: 0.5,
                    y: 0.5,
                    scale: 1,
                    angle: 0,
                  },
                ],
              },
            };
          }),

          position: state.active?.position || 'center',
        },
      };
    }

    case actions.EDIT_MERCH_IMAGE: {
      const { data, id } = action;
      let prevImages;
      let Index;
      if (id) {
        prevImages = state?.active?.image ? [...state.active.image] : [];
        Index = prevImages.findIndex((img) => img?.key === id);
        if (Index !== -1 && data[0]) prevImages[Index] = data[0];
      }
      return {
        ...state,
        active: {
          ...state.active,
          image:
            id && Index !== -1
              ? [...(prevImages as Partial<AssetFile>[])]
              : state?.active?.image
              ? ([...state?.active?.image, ...data] as Partial<AssetFile>[])
              : (action.data as Partial<AssetFile>[]), // ts error for passign action data as undefined
        },
      };
    }

    case actions.UPLOAD_MERCH_IMAGE: {
      return {
        ...state,
        active: {
          ...state.active,
          image: state.active?.image?.map((image) => {
            if (image.key === action.data.key) {
              return { ...image, ...action.data };
            } else {
              return { ...image };
            }
          }),
        },
      };
    }
    case actions.UPDATE_MERCH_PRODUCT_POSITION: {
      return {
        ...state,
        active: {
          ...state.active,
          selectedPosition: action.position,
        },
      };
    }
    case actions.UPDATE_MERCH_STORE: {
      if (
        action.merch?.product &&
        action.merch.product.id !== state.active?.product?.id
      ) {
        return {
          ...state,
          active: {
            ...state.active,
            ...action.merch,
            colorSize: undefined,
            selectedSizes: undefined,
            selectedColors: undefined,
          },
        };
      }
      return {
        ...state,
        active: {
          ...state.active,
          ...action.merch,
        },
      };
    }

    case CHANGE_MERCH_TYPE_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          product: action.product || state.active?.product,
          colorSize: undefined,
          selectedSizes: undefined,
          selectedColors: undefined,
          productData: undefined,
          editProduct: undefined,
          newProduct: undefined,
          image: undefined,
          position: 'center',
          availablePositions: action.product?.placeholders
            ? action.product?.placeholders?.L
            : [{ position: 'front', height: 0, width: 0 }],
        },
      };
    }

    case CHANGE_MERCH_COLOR: {
      return {
        ...state,
        active: {
          ...state.active,
          selectedColors: action.colors,
        },
      };
    }

    case CHANGE_MERCH_DESIGN_POSITION: {
      return {
        ...state,
        active: {
          ...state.active,
          position: action.position,
        },
      };
    }

    case actions.GET_CATALOG_ITEM_SUCCESS: {
      const availableColors: CatalogItemColor[] = !!action.data.colors?.length
        ? action.data.colors.reduce(
            (
              acc: { colors: string[]; colorsObj: CatalogItemColor[] },
              color
            ) => {
              if (color.color && !acc.colors.includes(color.color)) {
                return {
                  colors: [...acc.colors, color.color],
                  colorsObj: [...acc.colorsObj, color],
                };
              }
              return acc;
            },
            { colors: [], colorsObj: [] }
          ).colorsObj
        : [
            {
              label: 'Unique Color',
              color: 'UNIQUE',
              id: -1,
              src: action.data.images[0],
            },
          ];

      return {
        ...state,
        active: {
          ...state.active,
          colorSize: {
            ...action.data,
            colors: availableColors,
          },
          selectedColors:
            state.active?.selectedColors ||
            (availableColors && availableColors?.map((it) => it.label)),
          selectedSizes:
            state.active?.selectedSizes ||
            action.data.sizes?.map((it) => it.label),
          availablePositions: action.data?.placeholders
            ? action.data.placeholders?.L || action.data.placeholders?.M
            : [{ position: 'front', height: 0, width: 0 }],
        },
      };
    }

    case actions.CREATE_MERCH: {
      return {
        ...state,
        active: {
          ...state.active,
          newProduct: undefined,
        },
      };
    }

    case actions.CREATE_MERCH_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          newProduct: action.merch,
          productData: {
            productName: state.active?.product?.title || '',
            productPrice:
              action.merch?.pricing?.suggested_price.toString() || '0',
          },
        },
      };
    }
    case actions.EDIT_MERCH_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          ...formatData(action.editProduct),
          // product: action?.product || state.active?.product,
          editProduct: action.editProduct,
          position: action.editProduct.printify[0].position as RelativePosition,
          productData: {
            productName: action.editProduct.title || '',
            productPrice: action.editProduct.price.toString() || '0',
          },
          quantity: action.editProduct?.qty,
          isUnlimited: action.editProduct?.unlimitedQty,
        },
      };
    }

    case actions.UPDATE_MERCH_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          editProduct: action.editProduct,
          productData: {
            productName: action.editProduct.title,
            productPrice: action.editProduct.price.toString(),
          },
        },
      };
    }

    case PUBLISH_PRODUCT_SUCCESS: {
      return {
        ...state,
        artistMerch: state.artistMerch?.map((value) => {
          if (value.id === action.productId) {
            return { ...value, status: 'published' };
          }
          return value;
        }),
      };
    }

    case actions.CLEAN_MERCH_STORE: {
      return {
        ...merchInitialState,
      };
    }

    case actions.DELETE_MERCH_SUCCESS: {
      const product = state.artistMerch.find(
        (prod) => prod.id === action.productId
      );
      return {
        ...state,
        active: {
          ...state.active,
        },
        artistMerch:
          product?.status === 'published'
            ? state.artistMerch?.map((prod) => {
                if (prod.id === action.productId) {
                  return { ...prod, status: 'draft' };
                }
                return prod;
              })
            : state.artistMerch?.filter(
                (prod) => prod.id !== action.productId
              ) || [],
      };
    }

    case actions.LIST_ARTIST_MERCH: {
      return {
        ...state,
        loaded: false,
      };
    }

    case actions.LIST_ARTIST_MERCH_SUCCESS: {
      let isNewMerch =
        action.merch.length > state.artistMerchCount ? true : false;
      return {
        ...state,
        artistMerch: action.merch,
        loaded: true,
        isNewMerch: isNewMerch,
        artistMerchCount: action.merch.length,
      };
    }

    case actions.UPDATE_IS_NEW_MERCH: {
      return {
        ...state,
        isNewMerch: action.isNewMerch,
      };
    }

    case actions.UPDATE_MERCH_ORDER: {
      return {
        ...state,
        artistMerch: state.artistMerch.map((value) => {
          const newIndex = action.newOrder.findIndex((id) => id === value.id);
          if (newIndex >= 0) {
            return { ...value, order: newIndex };
          }
          return value;
        }),
      };
    }
    case actions.UPDATE_MERCH_IMAGES: {
      return {
        ...state,
        active: {
          ...state.active,
          image: action.images,
        },
      };
    }
    case actions.UPDATE_MERCH_PRODUCT_SAMPLE_ORDER: {
      return {
        ...state,
        active: {
          ...state.active,
          productSample: action.data,
        },
      };
    }
    case actions.CREATE_MERCH_PRODUCT_SAMPLE_ORDER_SUCCESS: {
      return {
        ...state,
        active: {
          ...state.active,
          productSampleOrder: action.data,
        },
      };
    }
    case actions.GET_MERCH_SAMPLE_ORDER_SHIPPING_COST_SUCCESS: {
      const shippingOptions: ShippingOption[] = [];
      if (action.data.standard) {
        shippingOptions.push({
          shipping_rate_data: {
            ...StandardShippingOption,
            fixed_amount: { amount: action.data.standard, currency: 'usd' },
          },
        });
      }
      if (action.data.express) {
        shippingOptions.push({
          shipping_rate_data: {
            ...ExpressShippingOption,
            fixed_amount: { amount: action.data.express, currency: 'usd' },
          },
        });
      }
      return {
        ...state,
        active: {
          ...state.active,
          productSample: {
            ...(state.active?.productSample as ProductSample),
            shippingPrice: { ...action.data },
          },
          productSampleOrder: {
            ...(state.active
              ?.productSampleOrder as CreateSampleOrderSuccessResponse),
            shippingOptions,
          },
        },
      };
    }
    default: {
      return { ...state };
    }
  }
};

function formatData(product?: MerchProduct): Partial<Merch> {
  if (product) {
    const formatColors = product.colors.map((color) => {
      return { id: color.id, label: color.name };
    });
    const formatSizes = product.sizes.map((size) => {
      return { id: size.id, label: size.name };
    });
    const selectedColors = formatColors.map((color) => color.id);
    const selectedSizes = formatSizes.map((size) => size.id);

    const formatSelectedColors: string[] = selectedColors
      .map(
        (colorId) =>
          formatColors?.find((color) => color.id === colorId)?.label || ''
      )
      .filter((colorId) => !!colorId);

    const formatSelectedSizes: string[] = selectedSizes
      .map(
        (sizeId) => formatSizes?.find((size) => size.id === sizeId)?.label || ''
      )
      .filter((sizeId) => !!sizeId);

    return {
      selectedColors: formatSelectedColors,
      selectedSizes: formatSelectedSizes,
      image: product.printify.map((image) => {
        return {
          ...image,
          url: image.image,
          id: image.imageId,
        };
      }),
    };
  }
  return {};
}
